import { render, staticRenderFns } from "./SideMenuDrawer.vue?vue&type=template&id=2cca795c&scoped=true&"
import script from "./SideMenuDrawer.vue?vue&type=script&lang=ts&setup=true&"
export * from "./SideMenuDrawer.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./SideMenuDrawer.vue?vue&type=style&index=0&id=2cca795c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cca795c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cca795c')) {
      api.createRecord('2cca795c', component.options)
    } else {
      api.reload('2cca795c', component.options)
    }
    module.hot.accept("./SideMenuDrawer.vue?vue&type=template&id=2cca795c&scoped=true&", function () {
      api.rerender('2cca795c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/core-layout/components/CoreHeader/components/mobile/SideMenu/SideMenuDrawer.vue"
export default component.exports